import { AdhesionResumeInterface } from '../../../../interfaces/dto/sales-portal/adhesion-resume/adhesion-resume-interface';
import { AdhesionDataModel, AdhesionInsuredPeopleModel } from '@fh-client-interaction-frontends/fh-data-access-adhesion';
import { AdhesionPaymentResumeModel } from '../adhesion-payment/adhesion-payment-resume-model';

export class AdhesionResumeModel implements AdhesionResumeInterface {
  policyHolderData: AdhesionDataModel = new AdhesionDataModel();
  insuredPeople: AdhesionInsuredPeopleModel[] = new Array<AdhesionInsuredPeopleModel>();
  subscriptionData: AdhesionPaymentResumeModel = new AdhesionPaymentResumeModel();

  constructor(init?: Partial<AdhesionResumeModel>) {
    Object.assign(this, init);
  }
}
